
export const NameHeading = () => (
    <div>
        <h2 style={{ fontFamily: 'sans-serif' }}>〘 Prakruti Ayurvedic Health Center & Hospital 〙</h2>
        <h4 style={{ fontFamily: 'fantasy', textAlign: 'center' }}>
            A Project By Prakruti Ayurvedic Health Resort, Satara
        </h4>
    </div>
);
